import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faNetworkWired,
  faUser,
  faFileSignature,faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Card,
  Row,
  Table,
  Button,
  ListGroup,
  Badge,Dropdown,ButtonGroup
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import axios from "axios";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { getDashboard ,getFetchContractsTemplate} from "../../app/api";
import Loader from "../../components/Loader";
export default () => {
  const [loading, setLoading] = useState(true);
  const [totalVendor, setTotalVendor] = useState("");
  const [totalasset, setTotalAsset] = useState("");
  const [totalcontract, setTotalContract] = useState("");
  const [vendorData, SetVendorData] = useState([]);
  const [contractData, setContractData] = useState([]);
  const accesstoken = localStorage.getItem("adobe_access_token");
    const handleAdobeFetchContract = async () => {
      // Retrieve environment variables
      try {
        const token = localStorage.getItem("token");
  
        const response = await axios.get(getFetchContractsTemplate(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
            accessToken: accesstoken,
          },
        });
      
      } catch (error) {
       
      }
    };
  const fetchDashboard = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getDashboard(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      SetVendorData(response.data?.data?.latest_vendors);
      setContractData(response.data?.data?.latest_contracts);
      setTotalVendor(response.data?.data?.total_vendors);
      setTotalAsset(response.data?.data?.total_assets);
      setTotalContract(response.data?.data?.total_contracts);
      handleAdobeFetchContract()
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false); // Hide loader after fetching data
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              <h4 className="mb-0">Dashboard</h4>
              {/* <p className="mb-0">Your web analytics dashboard template.</p> */}
            </div>
           
                        <Dropdown as={ButtonGroup}>
                                                    <Dropdown.Toggle
                                                      as={Button}
                                                      split
                                                      variant="primary"
                                                      
                                                    >
                                                       <FontAwesomeIcon icon={faPlus} className="me-2" />
                                                       <span>Quick Add</span>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                      <Dropdown.Item>
                                                        <Link
                                                          className="me-2"
                                                          to={`${Routes.AddVendor.path}`}
                                                        >
                                                          {" "}
                                                          <FontAwesomeIcon
                                                            icon={faUser}
                                                            className="me-2"
                                                          />{" "}
                                                          Vendors
                                                        </Link>
                                                      </Dropdown.Item>
                                                      <Dropdown.Item>
                                                        <Link
                                                          as={Link}
                                                          to={`${Routes.AssetsAdd.path}`}
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faNetworkWired}
                                                            className="me-2"
                                                          />{" "}
                                                          Assets{" "}
                                                        </Link>
                                                      </Dropdown.Item>
                                                      <Dropdown.Item >
                                                      <Link
                                                          className="me-2"
                                                          to={`${Routes.ContractsAdd.path}`}
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faFileSignature}
                                                            className="me-2"
                                                          />{" "}
                                                          Contracts
                                                       </Link>
                                                      </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                  </Dropdown>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={6} xl={4} className="mb-4">
              <Card border="light" className="shadow-sm Dashboard_cards">
                <Link to={`${Routes.Vendors.path}`}>
                  <Card.Body>
                    <Row className="d-block d-xl-flex align-items-center">
                      <Col
                        xl={5}
                        className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
                      >
                        <div
                          className={`icon icon-shape icon-md  rounded me-4 me-sm-0`}
                        >
                          <FontAwesomeIcon icon={faUser} />
                        </div>
                        <div className="d-sm-none">
                          <p>Vendors</p>
                          <p className="mb-1">{totalVendor}</p>
                        </div>
                      </Col>
                      <Col xs={12} xl={7} className="px-xl-0">
                        <div className="d-none d-sm-block">
                          <p>Vendors</p>
                          <p className="mb-1">{totalVendor}</p>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Link>
              </Card>
            </Col>

            <Col xs={12} sm={6} xl={4} className="mb-4">
              <Card border="light" className="shadow-sm Dashboard_cards">
                <Link to={`${Routes.Assets.path}`}>
                  <Card.Body>
                    <Row className="d-block d-xl-flex align-items-center">
                      <Col
                        xl={5}
                        className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
                      >
                        <div
                          className={`icon icon-shape icon-md  rounded me-4 me-sm-0`}
                        >
                          <FontAwesomeIcon icon={faNetworkWired} />
                        </div>
                        <div className="d-sm-none">
                          <p>Assets</p>
                          <p className="mb-1">{totalasset}</p>
                        </div>
                      </Col>
                      <Col xs={12} xl={7} className="px-xl-0">
                        <div className="d-none d-sm-block">
                          <p>Assets</p>
                          <p className="mb-1">{totalasset}</p>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Link>
              </Card>
            </Col>

            <Col xs={12} sm={6} xl={4} className="mb-4">
              <Card border="light" className="shadow-sm Dashboard_cards">
                <Link to={`${Routes.Contracts.path}`}>
                  <Card.Body>
                    <Row className="d-block d-xl-flex align-items-center">
                      <Col
                        xl={5}
                        className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
                      >
                        <div
                          className={`icon icon-shape icon-md  rounded me-4 me-sm-0`}
                        >
                          <FontAwesomeIcon icon={faFileSignature} />
                        </div>
                        <div className="d-sm-none">
                          <p>Contracts</p>
                          <p className="mb-1">{totalcontract}</p>
                        </div>
                      </Col>
                      <Col xs={12} xl={7} className="px-xl-0">
                        <div className="d-none d-sm-block">
                          <p>Contracts</p>
                          <p className="mb-1">{totalcontract}</p>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Link>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xs={12} xl={12} className="mb-4">
              <Row>
                <Col xs={12} xl={8}>
                  <Row>
                    <Col xs={12}>
                      <Card border="light" className="shadow-sm">
                        <Card.Header>
                          <Row className="align-items-center">
                            <Col>
                              <p>Recent Vendors</p>
                            </Col>
                            <Col className="text-end">
                              <Button
                                variant="primary"
                                as={Link}
                                to={`${Routes.Vendors.path}`}
                                size="sm"
                              >
                                See all
                              </Button>
                            </Col>
                          </Row>
                        </Card.Header>
                        <Table
                          responsive
                          className="align-items-center table-flush"
                        >
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">ID</th>
                              <th scope="col">Vendor Name</th>
                              <th scope="col">Company</th>
                              <th scope="col">Status</th>
                              {/* <th scope="col">Action</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {vendorData?.map((vendors, index) => (
                              <tr>
                                <th scope="row">
                                  {" "}
                                  <Link
                                    className="Link_underline"
                                    to={`${Routes.VendorDetail.path}/${vendors.id}`}
                                  >
                                    {vendors?.vendor_ID}
                                  </Link>{" "}
                                </th>
                                <td>{vendors?.vendor_name}</td>
                                <td>{vendors?.vcompany}</td>
                                <td>
                                <Badge
                            pill
                            bg="primary"
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.85rem",
                              border: "1px solid #ddd",
                            }}
                          >
                            {vendors?.regstatus}
                          </Badge>
                                </td>
                                {/* <td>
                  <Link to={`${Routes.VendorDetail.path}/${vendors.id}`}><FontAwesomeIcon icon={faEye} className="me-3"  /></Link> 
                  <Link
                                                      as={Link}
                                                      to={`${Routes.AddVendor.path}/${vendors.id}`}
                                                    ><FontAwesomeIcon icon={faEdit} className="me-3" /></Link>
                  <FontAwesomeIcon icon={faBuilding}  className="me-3" />
                  </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Card>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} xl={4}>
                  <Row>
                    <Col xs={12} className="mb-4">
                      <Card border="light" className="shadow-sm">
                        <Card.Header className="border-bottom border-light d-flex justify-content-between">
                          <p className="mb-0">Latest Signed Contracts</p>
                          <Button
                            variant="primary"
                            size="sm"
                            as={Link}
                            to={`${Routes.Contracts.path}`}
                          >
                            See all
                          </Button>
                        </Card.Header>
                        <Card.Body>
                          <ListGroup className="list-group-flush list my--3">
                            {contractData?.map((contract, index) => (
                              <ListGroup.Item className="px-0">
                                <Row className="align-items-center">
                                  <Col className="ms--2">
                                    {/* <h4 className="h6 mb-0">
                    <a href="#!">{contract.id}</a>
                  </h4> */}
                                    <Link
                                      className="Link_underline"
                                      to={`${Routes.ContractsDetail.path}/${contract.id}`}
                                    >
                                      <p className="Link_underline">
                                        {contract.vendor_name}{" "}
                                      </p>
                                    </Link>
                                  </Col>
                                  <Col className="col-auto">
                                    <p>
                                      {contract.signdate ===
                                      "0000-00-00 00:00:00" || contract?.signdate === null
                                        ? "Not Signed"
                                        : `${contract.signdate}`}{" "}
                                    </p>
                                  </Col>
                                </Row>
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
